// Pagination — "Page X of Y" with prev/next and an optional page-size select.
// Strategy-agnostic (offset/cursor): the parent decides what page change means.
// Required element of the List screen type (Frontend Rules §8/§13).
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { cx } from '../../../utils/cx';
import { CaretIcon } from '../../icons/Icons';
import './pagination.css';

export function Pagination({
  page,
  pageCount,
  onPage,
  pageSize,
  pageSizeOptions = [10, 20, 50],
  onPageSize,
  className,
}) {
  const { t } = useTranslation();
  const canPrev = page > 1;
  const canNext = page < pageCount;
  return (
    <div className={cx('pagination', className)}>
      {onPageSize && (
        <label className="pagination__size">
          {t('reusable.pagination.rows')}
          <select value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))}>
            {pageSizeOptions.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
      )}
      <span className="pagination__status">
        {t('reusable.pagination.pageOf', { page, count: Math.max(1, pageCount) })}
      </span>
      <div className="pagination__nav">
        <button type="button" className="pagination__btn" disabled={!canPrev} onClick={() => onPage(page - 1)} aria-label={t('reusable.pagination.prev')}>
          <CaretIcon style={{ transform: 'rotate(90deg)' }} />
        </button>
        <button type="button" className="pagination__btn" disabled={!canNext} onClick={() => onPage(page + 1)} aria-label={t('reusable.pagination.next')}>
          <CaretIcon style={{ transform: 'rotate(-90deg)' }} />
        </button>
      </div>
    </div>
  );
}

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  onPage: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  onPageSize: PropTypes.func,
  className: PropTypes.string,
};

export default Pagination;
